import { render, staticRenderFns } from "./searchFolioComponent.vue?vue&type=template&id=b8a8cfd0"
import script from "./searchFolioComponent.vue?vue&type=script&lang=js"
export * from "./searchFolioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports